export const getOpen = (state) => state.authorisePayment.open;
export const getDialogId = (state) => state.authorisePayment.dialogId;
export const getLoading = (state) => state.authorisePayment.loading;
export const getSelectedCard = (state) => state.authorisePayment.selectedCard;
